import AppContentTitles from "../AppContentTitles";
import ManageContentTable from "./ManageContentTable";

const ManageContentPage = () => {
  return (
    <div className="main-container">
      <AppContentTitles
        title="Content Management"
        description="Filter unwanted content by entering keywords, selecting content types for automatic filtering and adding country-specific terms."
      />
      <ManageContentTable />
    </div>
  );
};

export default ManageContentPage;
